/**
 * Legal Counsel contact responsible for an invoice.
 *
 * Fixed enum of the legal team; the stored value is the person's full name
 * itself. `null` = not yet assigned. Mirrors the InvoiceEntity / PO-column
 * singleSelect pattern used elsewhere in the Database table.
 */
export type LegalCounsel =
  | 'Bastian Grimm'
  | 'Theresia Gondro'
  | 'Kristina Breunig'
  | 'Philipp Nothaft'
  | 'Manuel Detzel'
  | 'Lorenz Erik Wittjen'
  | 'Friederike Nägelsbach'
  | 'Sebastian Kroher'
  | 'Katja Güttler'
  | 'Benedikt Lehmann'
  | 'Michael Beder'

export const LEGAL_COUNSELS: LegalCounsel[] = [
  'Bastian Grimm',
  'Theresia Gondro',
  'Kristina Breunig',
  'Philipp Nothaft',
  'Manuel Detzel',
  'Lorenz Erik Wittjen',
  'Friederike Nägelsbach',
  'Sebastian Kroher',
  'Katja Güttler',
  'Benedikt Lehmann',
  'Michael Beder',
]

/** singleSelect options for the DataGrid (incl. an "Unassigned" / null choice). */
export const LEGAL_COUNSEL_OPTIONS: { value: LegalCounsel | null; label: string }[] = [
  { value: null, label: 'Unassigned' },
  ...LEGAL_COUNSELS.map((value) => ({ value, label: value })),
]

/** Coalesce an unknown/legacy value to a valid Legal Counsel, or null. */
export function normalizeLegalCounsel(value: string | null | undefined): LegalCounsel | null {
  return LEGAL_COUNSELS.includes(value as LegalCounsel) ? (value as LegalCounsel) : null
}
